import React, { useState, useEffect } from 'react';
import './metrics.css';
import { Line, Pie, Bar } from 'react-chartjs-2';
import Flask from './Flask';
import GenWiz from '../common/Popups/Genwizui';
import MetricSkel from './MetricSkel';
import DisplayNumbers from './subcomponent/DisplayNumbers';
import {
    setMonth,
    getServerCount,
    getOrderCount,
    getOrderGraph,
    getServerGraph,
    getServerType,
    getServerRegion,
    getAssetCount,
    getApproval
} from './datachart/Action';

export default function Metrics() {

    const [isLoading, setLoading] = useState(true);
    const [serverCount, setServerCount] = useState({
        'running': 0,
        'stopped': 0,
        'terminated': 0
    })
    const [orderCount, setOrderCount] = useState({
        'fulfilled': 0,
        'failed': 0
    });
    const [gwconfig, setgenwiz] = useState({
        stateFunction: setgenwiz
    });

    const [isOpen, setOpen] = useState(true)
    const [graphData, setGraphData] = useState([])
    const [monthNames, setMonthNames] = useState([])
    const [serverGdata, setServerGdata] = useState([])
    const [serverType, setServerType] = useState([])
    const [serverRegion, setServerRegion] = useState([])
    const [orderAsset, setOrderAsset] = useState([])
    const [filterData, setFilterData] = useState({
        environment: '',
        region: '',
        client: '',
        product: '',
        fromdate: '',
        todate: ''
    })

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Order Request Per Month',
            },
        },
    };

    const labels = monthNames;
    //order bar graph
    const dataOpt01 = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: false,
            text: 'Order Asset Type',
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    };
    const dataSet01 = {
        labels: Object.keys(orderAsset),
        datasets: [
            {
                label: [],
                data: Object.values(orderAsset),
                backgroundColor: '#934BC9',
                borderColor: '#934BC9'
            }
        ],
    };
    //order pie chart
    const dataOpt02 = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        legend: {
            position: 'top',
            display: false,
        },
        title: {
            display: true,
            text: 'Client Order',
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    };
    const dataSet02 = {
        labels: Object.keys(serverType),
        datasets: [{
            label: 'counts',
            data: Object.values(serverType),
            fill: false,
            backgroundColor: ['#F44475', '#66039f'],
            borderColor: '#FFFFFF',
        }]
    };
    //order line graph
    const dataOpt03 = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Order Request Per Month',
        },
    };
    const dataSet03 = {
        labels,
        datasets: [
            {
                label: 'Fulfilled',
                data: graphData[0],
                borderColor: '#27A3B2',
                backgroundColor: 'transparent',
                lineTension: 0,
                pointBackgroundColor: '#27A3B2',
                fillStyle: '#eccb0f',
            },
            {
                label: 'Failed',
                data: graphData[1],
                backgroundColor: 'transparent',
                borderColor: '#F44475',
                lineTension: 0,
                pointBackgroundColor: '#F44475',
                fillStyle: '#F44475',
            },
            {
                label: 'Total',
                data: graphData[2],
                backgroundColor: 'transparent',
                borderColor: '#934BC9',
                lineTension: 0,
                pointBackgroundColor: '#934BC9',
                fillStyle: '#934BC9',
            },
        ],
    };


    //server pie chart 2
    const dataOpt07 = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Server Status',
            },
        },
    };
    const dataSet07 = {
        labels: Object.keys(serverCount),
        datasets: [{
            label: 'Count',
            data: Object.values(serverCount),
            fill: false,
            backgroundColor: ['#66039f', '#F44475'],
            borderColor: '#FFFFFF',
            tension: 0.1
        }]
    };

    //sever bar graph
    const dataOpt04 = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        legend: {
            position: 'top',
            display: false
        },
        title: {
            display: true,
            text: 'Running Server per Region',
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    };
    const dataSet04 = {
        labels: Object.keys(serverRegion),
        datasets: [
            {
                label: 'Count',
                data: Object.values(serverRegion),
                backgroundColor: '#934BC9',
                borderColor: '#934BC9'
            }
        ],
    };

    const data = {
        labels,
        datasets: [
            {
                label: 'Fulfilled',
                data: graphData[0],
                backgroundColor: 'transparent',
                borderColor: '#66039f',
                tension: 0
            },
            {
                label: 'Failed',
                data: graphData[1],
                backgroundColor: 'transparent',
                borderColor: '#F7D000',
                tension: 0
            },
        ],
    };

    // SHITTING
    const options2 = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRato: 2,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Server',
            },
        },
    };

    const data3 = {
        labels: Object.keys(serverGdata),
        datasets: [{
            label: 'Server Types',
            data: Object.values(serverGdata),
            backgroundColor: [
                '#F44475',
                '#66039f',
                '#27A3B2',
            ],
            hoverOffset: 4
        }]
    };

    const onload = async () => {
        const idToken = localStorage.getItem("token");

        if (idToken === null || idToken === undefined) {
            window.location.href = "/"
            return false;
        }
        const urloptions = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": idToken,
            }
        };
        setgenwiz({
            appName: 'gwLoading',
            config: {
                stateFunction: setgenwiz,
                text: 'Fetching Data',
            }
        });
        await getOrderCount(setOrderCount, filterData, urloptions);
        await getServerCount(setServerCount, filterData, urloptions);
        await getOrderGraph(setGraphData, filterData, urloptions);
        await getServerGraph(setServerGdata, filterData, urloptions);
        await getServerType(setServerType, filterData, urloptions);
        await getServerRegion(setServerRegion, filterData, urloptions);
        await getAssetCount(setOrderAsset, filterData, urloptions);
        // await getApproval('',filterData,urloptions);
        setMonthNames(setMonth());
        setLoading(false);
        setgenwiz({
            status: 'hide'
        });
    }

    const uploadToggle = () => {
        var elm = document.getElementById('db-upload-container');
        elm.classList.toggle("show");
    }

    const fileChange = (e) => {
        let filename = e.target.value.replace("C:\\fakepath\\", "");
        if (filename === "")
            filename = "Choose a File"
        document.getElementById('upload-filename').innerText = filename
    }

    const uploadFile = () => {
        //display loading
        uploadToggle();
        setgenwiz({
            appName: 'gwLoading',
            config: {
                stateFunction: setgenwiz,
                text: 'Uploading Data',
            }
        });
        const idToken = localStorage.getItem("token");

        if (idToken === null || idToken === undefined) {
            window.location.href = "/"
            return false;
        }
        const urloptions = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": idToken,
            }
        };

        var formData = new FormData();
        var splunkfile = document.getElementById('splunk-order');
        var camevn = document.getElementById('camenv');

        formData.append("camenv", camevn.value);
        formData.append("splunkorder", splunkfile.files[0]);

        Flask.post('/api-cam/upload', formData, urloptions).then((response) => {
            setgenwiz({
                appName: 'gwAlert',
                config: {
                    stateFunction: setgenwiz,
                    text: 'Upload Complete',
                }
            });
        }).catch((error) => {
            setgenwiz({
                appName: 'gwAlert',
                config: {
                    stateFunction: setgenwiz,
                    text: 'Upload Error',
                }
            });
        });
    }

    const filterUpdate = (evt) => {
        const { name, value } = evt.target;
        setFilterData({ ...filterData, [name]: value });
    }

    useEffect(() => {
        onload();
    }, []);


    return (
        <>
            {isLoading ?
                <MetricSkel />
                :
                <div className='metrics-container'>
                    <div className="filter-action">
                        {/* <select name='environment' onChange={(e) => filterUpdate(e)}>
                            <option value="">All Environment</option>
                            <option value="prod">Production</option>
                            <option value="uat">UAT</option>
                        </select> */}
                        <select name='region' onChange={(e) => filterUpdate(e)}>
                            <option value="">All Region</option>
                            <option value="sydney">Sydney</option>
                            <option value="virginia">Virginia</option>
                            <option value="frankfurt">Frankfurt</option>
                            <option value="singapore">Singapore</option>
                            <option value="tokyo">Tokyo</option>
                            <option value="ireland">Ireland</option>
                            <option value="sao paulo">SaoPaulo</option>
                            <option value="london">London</option>

                        </select>
                        <select name='client' onChange={(e) => filterUpdate(e)}>
                            <option value="">All Client</option>
                            <option value="internal">Internal</option>
                            <option value="external">External</option>
                        </select>
                        <select name='product' onChange={(e) => filterUpdate(e)}>
                            <option value="">All Product</option>
                            <option value="Plain Instance">Plain Instance</option>
                            <option value="AD Platform">AD Platform</option>
                            <option value="UKTM Platform">UKTM Platform</option>
                            {/* <option value="ATR Caas">ATR Caas</option>
                            <option value="ATR Saas">ATR Caas</option> */}
                            <option value="ATR Platform">ATR Platform</option>
                            {/* <option value="Managed Platform">Managed Platform</option> */}
                            <option value="Automation Anywhere Licenses">Automation Anywhere Licenses</option>
                            <option value="Dedicated Platform">Dedicated Platform</option>
                            <option value="EventOps Platform">EventOps Platform</option>
                            {/* <option value="KM Platform">KM Platform</option> */}
                            <option value="OnPremise">OnPremise</option>
                            <option value="Q++ Platform">Q++ Platform</option>
                            {/* <option value="Quasar Caas">Quasar Caas</option>
                            <option value="Stormseer Platform">Stormseer Platform</option> */}
                            <option value="Ticket Analytics">Ticket Analytics</option>
                            <option value="Service Integrator">Service Integrator</option>
                            <option value="EC2 Claude">EC2 Claude</option>
                            <option value="PAM">PAM</option>
                        </select>
                        <input type="text" name="fromdate" onChange={(e) => filterUpdate(e)} placeholder="From Date" onFocus={e => e.target.type = 'date'} onBlur={e => e.target.type = 'text'} />
                        <input type="text" name="todate" onChange={(e) => filterUpdate(e)} placeholder="To Date" onFocus={e => e.target.type = 'date'} onBlur={e => e.target.type = 'text'} />
                        <input type="button" value="Filter" onClick={(e) => onload()} />
                        {/* <input type="button" value="Upload" style={{ float: 'right' }} onClick={() => uploadToggle()} /> */}
                    </div>
                    <div className='details01'>
                        <div className="box01" style={{ border: 'none', boxShadow: 'none' }}>
                            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0px 0' }}>
                                <div style={{ width: '32%', height: '90%', margin: '0 5px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
                                    <span className='title-task'>Fulfilled Order</span>
                                    <div className='number-task'>
                                        <DisplayNumbers number={(isNaN(orderCount['fulfilled']) ? 0 : parseInt(orderCount['fulfilled']))} />
                                    </div>
                                </div>
                                <div style={{ width: '32%', height: '90%', margin: '0 5px', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
                                    <span className='title-task'>Failed Order</span>
                                    <div className='number-task'>
                                        <DisplayNumbers number={(isNaN(orderCount['failed']) ? 0 : parseInt(orderCount['failed']))} />
                                    </div>
                                </div>
                                <div style={{ width: '32%', height: '90%', margin: '0 0 0 5px', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
                                    <span className='title-task'>Total Order</span>
                                    <div className='number-task'>
                                        <DisplayNumbers number={(isNaN(orderCount['failed']) ? 0 : parseInt(orderCount['failed'])) + (isNaN(orderCount['fulfilled']) ? 0 : parseInt(orderCount['fulfilled']))} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box01" style={{ border: 'none', boxShadow: 'none' }}>
                            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0' }}>
                                <div style={{ width: '32%', height: '90%', margin: '0 5px 0 0', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
                                    <span className='title-task'>Running Server</span>
                                    <div className='number-task'>
                                        <DisplayNumbers number={(isNaN(serverCount['running']) ? 0 : parseInt(serverCount['running']))} />
                                    </div>
                                </div>
                                <div style={{ width: '32%', height: '90%', margin: '0 5px', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
                                    <span className='title-task'>Stopped Server</span>
                                    <div className='number-task'>
                                        <DisplayNumbers number={(isNaN(serverCount['stopped']) ? 0 : parseInt(serverCount['stopped']))} />
                                    </div>
                                </div>
                                <div style={{ width: '32%', height: '90%', margin: '0 0 0 5px', border: '1px solid #EBEBEB', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', position: 'relative', borderRadius: '8px' }}>
                                    <span className='title-task'>Total Server</span>
                                    <div className='number-task'>
                                        <DisplayNumbers number={(isNaN(serverCount['running']) ? 0 : parseInt(serverCount['running'])) + (isNaN(serverCount['stopped']) ? 0 : parseInt(serverCount['stopped']))} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="details02" style={{ display: 'inline-block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                        <div className="bbox" id='div-graph01' style={{ width: 'calc(50% - 32px)', display: 'flex', flexWrap: 'wrap', gap: '1em' }}>
                            <div style={{ width: '100%', height: '50%' }}>
                                <Line options={dataOpt03} data={dataSet03} />
                            </div>
                            <div style={{ width: '100%', height: '48%' }}>
                                <Bar options={dataOpt01} data={dataSet01} />
                            </div>
                        </div>
                        <div className="bbox" id='div-graph02' style={{ width: 'calc(50% - 32px)', display: 'flex', flexWrap: 'wrap', gap: '1em' }}>
                            <div style={{ width: '45%', height: '45%' }}>
                                <Bar options={dataOpt04} data={dataSet04} />
                            </div>
                            <div style={{ width: '45%', height: '45%' }}>
                                <Pie options={options2} data={data3} />
                            </div>
                            <div style={{ width: '45%', height: '45%' }}>
                                <Pie options={dataOpt07} data={dataSet07} />
                            </div>
                            <div style={{ width: '45%', height: '48%' }}>
                                <Bar options={dataOpt02} data={dataSet02} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            <GenWiz open={isOpen} appconfig={gwconfig} />
        </>
    )
}
